import * as d3 from 'd3-hierarchy'
import { useMemo } from 'react'

import useManageLocationsData from '../../tableV2/hooks/common/useManageLocations'

interface IDataType {
  id: 'string'
  parentId: 'string'
  code: 'string'
  name: 'string'
  startAt: 'string'
  endAt: 'string'
}

export const manageLocationsConfigs = {
  code: 'string',
  name: 'string',
  locationGroupType: 'string',
  locationGroupName: 'string',
  startAt: 'string',
  endAt: 'string',
}

const isData = (d: unknown): d is IDataType => true

const getData = (d: { data: unknown }) => {
  if (isData(d.data)) return d.data

  throw new Error('invalid data')
}

const useManageLocations = () => {
  const { data, loading } = useManageLocationsData()

  return {
    data: useMemo(() => {
      if (!data) return null

      const dataTree = d3.stratify()([
        ...data,
        {
          id: 'root',
        } as unknown,
      ] as IDataType[])
      const newData = dataTree
        .children!.sort(
          (a, b) => parseInt(getData(a).code) - parseInt(getData(b).code),
        )
        .map((d) =>
          d
            .children!.map((locationGroupNode) => [
              {
                code: getData(d).code,
                name: getData(d).name,
                locationGroupType: getData(locationGroupNode).code,
                locationGroupName: getData(locationGroupNode).name,
                startAt: getData(locationGroupNode).startAt,
                endAt: getData(locationGroupNode).endAt,
              },
              ...(locationGroupNode.children || []).map(
                (historyLocationGroupNode) => ({
                  code: getData(d).code,
                  name: getData(d).name,
                  locationGroupType: getData(locationGroupNode).code,
                  locationGroupName: getData(historyLocationGroupNode).name,
                  startAt: getData(historyLocationGroupNode).startAt,
                  endAt: getData(historyLocationGroupNode).endAt,
                }),
              ),
            ])
            .flat(),
        )
        .flat()

      return {
        source: newData,
        summary: null,
      }
    }, [data]),
    loading,
  }
}

export default useManageLocations
